export const DASHBOARD_NAMES = {
  TREASURY: 'TREASURY',
  HR: 'HR',
  TURNOVER: 'TURNOVER',
  DEBTORS: 'DEBTORS',
  CREDITORS: 'CREDITORS',
};
